import type { PayRequestEvent } from "./events/_pay-request.event";
import type { PayRequestId } from "./pay-request-id";

const firstEventMustBeACreatedEventCheck = (
    payRequestId: PayRequestId,
    events: PayRequestEvent[]
) => {
    if (events[0].type !== "PAY_REQUEST_CREATED_EVENT") {
        throw new Error(
            `The first event for a pay request must be PAY_REQUEST_CREATED_EVENT; payRequestId: ${payRequestId}`
        );
    }
};

export { firstEventMustBeACreatedEventCheck };
